import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import {UtilityService} from "../service/utility.service";

/**
 * @description Custom validator to check if a password and its confirmation match.
 * @export
 * @param {string} passwordControlName The name of the password form field.
 * @param {string} confirmPasswordControlName The name of the passwordConfirmation form field.
 * @returns {ValidationErrors | null}
 */
export function passwordsMatchValidator(passwordControlName: string, confirmPasswordControlName: string): ValidatorFn  {
  return (group: AbstractControl): ValidationErrors | null => {

    // Localize the value of the password form field.
    const password: string = group.get(passwordControlName)?.value?.toString().trim();

    // Localize the value of the passwordConfirmation form field.
    const passwordConfirmation: string = group.get(confirmPasswordControlName)?.value?.toString().trim();

    // Check for empty strings and return null if both are empty.
    if (UtilityService.IsEmptyString(password) && UtilityService.IsEmptyString(passwordConfirmation)) return null;

    // Check for equal strings and return null if both are equal.
    if (password === passwordConfirmation) return null;

    // We're done, the passwords don't match.
    return { passwordsMismatch: true };
  };
}
